/**
 * Route "/affiliate-manager-assignment" — operator page for assigning
 * internal managers to affiliate (publisher) accounts and inspecting the
 * per-manager workload grid. Registered via createRoute; the root wires
 * this into router.tsx after prod-main merge.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateManagerAssignmentPage } from "../features/affiliate-manager-assignment/AffiliateManagerAssignmentPage";

export const affiliateManagerAssignmentRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-manager-assignment",
	component: AffiliateManagerAssignmentPage,
});

export default affiliateManagerAssignmentRoute;
